
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30328',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30328",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54643",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8041",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11499",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "quartz": "static-1.7065",
  "quartz-config": "static-1.843",
  "quartz-core": "static-1.6284",
  "react-dlb": "static-1.79",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.798",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54630",
  "feedback-utils": "static-1.54634",
  "forms-embed-utils-lib": "static-1.4490",
  "forms-utils-lib": "static-1.12632",
  "foundations-assets": "static-1.4895",
  "foundations-components": "static-1.7987",
  "foundations-theming": "static-1.4447",
  "hub-http": "static-1.6249",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11806",
  "icons": "static-2.650",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3937",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-feature-id-1459-skip-old-browsers.3",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5365",
  "react-virtualized": "static-2.99",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.487",
  "tinymce-plugins": "static-1.57560",
  "transmute": "static-2.85",
  "ui-images": "static-2.1160",
  "UIComponents": "static-3.8445",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3419",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3342",
  "quartz-webpack": "static-1.3289",
  "foundations-theming-specialty": "static-1.2163",
  "property-description-translator": "static-1.3870",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3152",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4354",
  "jasmine-runner": "static-1.6491",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4672",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.740",
  "quartz-head": "static-1.730",
  "quartz-i18n": "static-1.740",
  "quartz-routing": "static-1.495",
  "quartz-test": "static-1.740",
  "quartz-tracking": "static-1.444",
  "ui-fonts": "static-1.761",
  "usage-tracker-container": "static-1.7365",
  "usage-tracker-core": "static-1.7225",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.156",
  "conversations-skeleton-state": "static-1.7275",
  "reference-resolvers": "static-1.8198",
  "sanitize-text": "static-1.8170",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10393",
  "sanitize": "static-1.4503",
  "outpost": "static-1.4206",
  "rpc-client-utils": "static-1.4679",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4256",
  "floating-ui": "static-1.56",
  "hs-story-utils": "static-1.9451",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2028",
  "bend-plugin-foundations-theming": "static-1.2930",
  "foundations-theming-base": "static-1.3432",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.101",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "ai-components-ui-library": "static-1.9039",
  "atom": "static-1.5100",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7791",
  "ContentUtils": "static-1.68446",
  "data-token-picker": "static-1.16451",
  "file-manager-components": "static-1.23696",
  "FileManagerCore": "static-1.39195",
  "FileManagerLib": "static-1.39336",
  "frontend-preferences-client": "static-1.7954",
  "hub-http-contrib": "static-1.3069",
  "interframe": "static-3.4787",
  "layout-dnd-components": "static-1.12494",
  "layout-dnd-utils": "static-1.11469",
  "property-translator": "static-1.5426",
  "react-codemirror": "static-1.10653",
  "react-colorpicker": "static-2.10235",
  "reference-resolvers-lite": "static-1.8122",
  "rich-text-lib": "static-1.19877",
  "tinymce-data": "static-1.40531",
  "tinymce-themes": "static-1.56416",
  "ui-addon-emoji-picker": "static-1.9915",
  "ui-addon-sales-email": "static-1.5238",
  "ui-brand-identity-lib": "static-1.15398",
  "bender-build-tools": "static-1.3215",
  "hub-http-shared-msw-handlers": "static-1.10028",
  "hubspotter-http-shared-msw-handlers": "static-1.10026",
  "usage-tracker-session-replay": "static-1.5061",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.89",
  "chirp-fetch": "static-1.1915",
  "chatspot-core": "static-1.21415",
  "copilot-toolkit": "static-1.11203",
  "customer-data-objects-ui-components": "static-1.13056",
  "data-fetching-client": "static-1.9694",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4788",
  "ui-addon-video-player": "static-1.8730",
  "ui-coaching-tips": "static-1.28637",
  "usage-tracker": "static-1.7375",
  "cms-field-types": "static-1.4839",
  "content-icons-ui": "static-1.2233",
  "integrations-lib": "static-1.16244",
  "customer-data-objects": "static-1.7700",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4679",
  "apollo-stack-hubspot": "static-3.86",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "immerable": "static-1.4181",
  "ui-addon-iframeable": "static-1.9087",
  "video-components-external": "static-1.11370",
  "video-data-lib": "static-1.35028",
  "audio-components": "static-1.5954",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29344",
  "FileManagerImages": "static-1.36847",
  "foundations-components-legacy": "static-1.1012",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.525",
  "ui-universal-auth": "static-1.9010",
  "urlinator": "static-1.4564",
  "video-components": "static-1.13373",
  "video-embed": "static-1.35862",
  "ts-schema": "static-1.4101",
  "ContentData": "static-1.68521",
  "layout-data-lib": "static-1.9794",
  "react-dnd-compat": "static-1.4642",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1569",
  "external-options-client-types": "static-1.4180",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6912",
  "hs-promise-utils": "static-1.5618",
  "inbound-db-properties-service-client": "static-1.3867",
  "NamespacedHubStyle": "static-2.9079",
  "growth-onboarding-confetti": "static-1.3094",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11176",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5570",
  "magpie-types": "static-1.5030",
  "simple-logging-lib": "static-1.3078",
  "avatar-components": "static-1.2525",
  "customer-data-ui-utilities": "static-1.9853",
  "growth-onboarding-feedback-components": "static-1.6607",
  "flux-actions": "static-1.341",
  "hubspot-apollo-client": "static-1.4906",
  "integrations-error-boundary-lib": "static-1.13659",
  "integrations-tracking-lib": "static-1.5629",
  "laboratory-lib": "static-3.7183",
  "native-integrations-shared-strings": "static-1.7809",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10197",
  "unified-auth": "static-1.524",
  "navigation-messaging": "static-1.7437",
  "content-media-composition-data-lib": "static-1.12419",
  "content-media-compositions": "static-2.16426",
  "idb-keyval": "static-1.44",
  "media-bridge-lib": "static-1.18970",
  "unified-auth-core-lib": "static-1.806",
  "social-insights-client-types": "static-1.22187",
  "advanced-menus-core": "static-1.15168",
  "advanced-menus-lib": "static-1.12106",
  "ExportDialog": "static-6.10411",
  "ui-memberships-settings-lib": "static-1.34121",
  "conditional-properties-service-client": "static-1.3818",
  "crm-pipelines-api-client-types": "static-1.4160",
  "fdsr-migration-layer": "static-1.31",
  "framework-builder-read-service-client": "static-1.4026",
  "framework-data-schema-quick-fetch": "static-1.6817",
  "inbound-db-meta-service-client": "static-1.3607",
  "multi-currency-client-types": "static-1.3712",
  "persist-promise": "static-1.3726",
  "foundations-components-test-utils": "static-1.5470",
  "reactive-lib": "static-1.750",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.365",
  "universal-page-editor-lib": "static-1.3040",
  "google-sheets-integration-lib": "static-1.319",
  "microsoft-drive-integration-lib": "static-1.444",
  "slack-ui-library": "static-1.10419",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3759",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15167",
  "simple-menus-lib": "static-1.16684",
  "crm-record-cards-service-types": "static-1.3615",
  "location-customization-utils-lib": "static-1.9342",
  "react-flip-move": "static-1.70"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30328",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54643",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8041",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11499",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "quartz": "/quartz/static-1.7065",
  "quartz-config": "/quartz-config/static-1.843",
  "quartz-core": "/quartz-core/static-1.6284",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.798",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54630",
  "feedback-utils": "/feedback-utils/static-1.54634",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4490",
  "forms-utils-lib": "/forms-utils-lib/static-1.12632",
  "foundations-assets": "/foundations-assets/static-1.4895",
  "foundations-components": "/foundations-components/static-1.7987",
  "foundations-theming": "/foundations-theming/static-1.4447",
  "hub-http": "/hub-http/static-1.6249",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11806",
  "icons": "/icons/static-2.650",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3937",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-skip-old-browsers.3",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5365",
  "react-virtualized": "/react-virtualized/static-2.99",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tinymce-plugins": "/tinymce-plugins/static-1.57560",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1160",
  "UIComponents": "/UIComponents/static-3.8445",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3419",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3342",
  "quartz-webpack": "/quartz-webpack/static-1.3289",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2163",
  "property-description-translator": "/property-description-translator/static-1.3870",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3152",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4354",
  "jasmine-runner": "/jasmine-runner/static-1.6491",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4672",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.740",
  "quartz-head": "/quartz-head/static-1.730",
  "quartz-i18n": "/quartz-i18n/static-1.740",
  "quartz-routing": "/quartz-routing/static-1.495",
  "quartz-test": "/quartz-test/static-1.740",
  "quartz-tracking": "/quartz-tracking/static-1.444",
  "ui-fonts": "/ui-fonts/static-1.761",
  "usage-tracker-container": "/usage-tracker-container/static-1.7365",
  "usage-tracker-core": "/usage-tracker-core/static-1.7225",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7275",
  "reference-resolvers": "/reference-resolvers/static-1.8198",
  "sanitize-text": "/sanitize-text/static-1.8170",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10393",
  "sanitize": "/sanitize/static-1.4503",
  "outpost": "/outpost/static-1.4206",
  "rpc-client-utils": "/rpc-client-utils/static-1.4679",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4256",
  "floating-ui": "/floating-ui/static-1.56",
  "hs-story-utils": "/hs-story-utils/static-1.9451",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2028",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2930",
  "foundations-theming-base": "/foundations-theming-base/static-1.3432",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.101",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9039",
  "atom": "/atom/static-1.5100",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7791",
  "ContentUtils": "/ContentUtils/static-1.68446",
  "data-token-picker": "/data-token-picker/static-1.16451",
  "file-manager-components": "/file-manager-components/static-1.23696",
  "FileManagerCore": "/FileManagerCore/static-1.39195",
  "FileManagerLib": "/FileManagerLib/static-1.39336",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7954",
  "hub-http-contrib": "/hub-http-contrib/static-1.3069",
  "interframe": "/interframe/static-3.4787",
  "layout-dnd-components": "/layout-dnd-components/static-1.12494",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11469",
  "property-translator": "/property-translator/static-1.5426",
  "react-codemirror": "/react-codemirror/static-1.10653",
  "react-colorpicker": "/react-colorpicker/static-2.10235",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8122",
  "rich-text-lib": "/rich-text-lib/static-1.19877",
  "tinymce-data": "/tinymce-data/static-1.40531",
  "tinymce-themes": "/tinymce-themes/static-1.56416",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9915",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5238",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15398",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10028",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10026",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5061",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.89",
  "chirp-fetch": "/chirp-fetch/static-1.1915",
  "chatspot-core": "/chatspot-core/static-1.21415",
  "copilot-toolkit": "/copilot-toolkit/static-1.11203",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13056",
  "data-fetching-client": "/data-fetching-client/static-1.9694",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4788",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8730",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28637",
  "usage-tracker": "/usage-tracker/static-1.7375",
  "cms-field-types": "/cms-field-types/static-1.4839",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "integrations-lib": "/integrations-lib/static-1.16244",
  "customer-data-objects": "/customer-data-objects/static-1.7700",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4679",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4181",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9087",
  "video-components-external": "/video-components-external/static-1.11370",
  "video-data-lib": "/video-data-lib/static-1.35028",
  "audio-components": "/audio-components/static-1.5954",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29344",
  "FileManagerImages": "/FileManagerImages/static-1.36847",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1012",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.525",
  "ui-universal-auth": "/ui-universal-auth/static-1.9010",
  "urlinator": "/urlinator/static-1.4564",
  "video-components": "/video-components/static-1.13373",
  "video-embed": "/video-embed/static-1.35862",
  "ts-schema": "/ts-schema/static-1.4101",
  "ContentData": "/ContentData/static-1.68521",
  "layout-data-lib": "/layout-data-lib/static-1.9794",
  "react-dnd-compat": "/react-dnd-compat/static-1.4642",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1569",
  "external-options-client-types": "/external-options-client-types/static-1.4180",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6912",
  "hs-promise-utils": "/hs-promise-utils/static-1.5618",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3867",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9079",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3094",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11176",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5570",
  "magpie-types": "/magpie-types/static-1.5030",
  "simple-logging-lib": "/simple-logging-lib/static-1.3078",
  "avatar-components": "/avatar-components/static-1.2525",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9853",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6607",
  "flux-actions": "/flux-actions/static-1.341",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4906",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13659",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5629",
  "laboratory-lib": "/laboratory-lib/static-3.7183",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7809",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10197",
  "unified-auth": "/unified-auth/static-1.524",
  "navigation-messaging": "/navigation-messaging/static-1.7437",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12419",
  "content-media-compositions": "/content-media-compositions/static-2.16426",
  "idb-keyval": "/idb-keyval/static-1.44",
  "media-bridge-lib": "/media-bridge-lib/static-1.18970",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.806",
  "social-insights-client-types": "/social-insights-client-types/static-1.22187",
  "advanced-menus-core": "/advanced-menus-core/static-1.15168",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12106",
  "ExportDialog": "/ExportDialog/static-6.10411",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34121",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3818",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4160",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.31",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4026",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6817",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3607",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3712",
  "persist-promise": "/persist-promise/static-1.3726",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5470",
  "reactive-lib": "/reactive-lib/static-1.750",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.365",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3040",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.319",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.444",
  "slack-ui-library": "/slack-ui-library/static-1.10419",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3759",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15167",
  "simple-menus-lib": "/simple-menus-lib/static-1.16684",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9342",
  "react-flip-move": "/react-flip-move/static-1.70"
}
};
